import { notificationFilterConstants } from '../constants';
import { notification } from './notification.reducer';

const initialState = { 
    id: null,
    view_comments: false,
    view_mentions: false,
    view_status: false,
    view_reminders: false,
    selected_filter: null, // comments, mentions, status, reminders
    organizations: [], // { id, name, workspaces: [{id, name}] }
    unselected_organization_ids: [],
    unselected_workspace_ids: []
};

export function notification_filter(state = initialState, action) {
  switch (action.type) {
    case notificationFilterConstants.SET_NOTIFICATION_FILTER: {
      const { id, view_comments, view_mentions, view_status, view_reminders } = action.payload;
      return {
        ...state,
        id,
        view_comments,
        view_mentions,
        view_status,
        view_reminders
      };
    }

    case notificationFilterConstants.UPDATE_NOTIFICATION_FILTER: {
      return {
        ...state,
        ...action.payload
      };
    }
    
    case notificationFilterConstants.SELECT_NOTIFICATION_FILTER: {
      return {
        ...state,
        selected_filter: action.payload
      };
    }

    case notificationFilterConstants.GET_ORGANIZATION_FILTERS:{
      return {
        ...state,
        organizations: action.payload
      }
    }

    case notificationFilterConstants.TOGGLE_UNSELECTED_ORGANIZATION: {
      const organization = action.payload;
      const includedAlready = state.unselected_organization_ids.includes(organization.id);

      let newUnSelectedOrganizationIds = includedAlready ?
          state.unselected_organization_ids.filter(id => id !== organization.id) :
          [...state.unselected_organization_ids, organization.id]

      const workspace_ids_in_org = organization.workspaces.map(w => w.id);

      return {
        ...state,
        unselected_organization_ids: newUnSelectedOrganizationIds,
        unselected_workspace_ids: state.unselected_workspace_ids.filter(id => 
          !workspace_ids_in_org.includes(id)
        ),
      };
    }

    case notificationFilterConstants.TOGGLE_UNSELECTED_WORKSPACE: {
      const workspace = action.payload;
      const organization = state.organizations.find(org => org.id === workspace.organization_id);
      
      if (!organization) {
        return handleWorkspaceToggle(state, workspace);
      }

      const isWorkspaceUnselected = state.unselected_workspace_ids.includes(workspace.id);
      const isOrgUnselected = state.unselected_organization_ids.includes(workspace.organization_id);
      const workspaceIdsInOrg = organization.workspaces.map(w => w.id);

      if (isOrgUnselected) {
        return handleOrgUnselectedCase(state, organization, workspace, workspaceIdsInOrg);
      }

      const updatedWorkspaceIds = isWorkspaceUnselected
      ? state.unselected_workspace_ids.filter(id => id !== workspace.id)
      : [...state.unselected_workspace_ids, workspace.id];

      const areAllWorkspacesUnselected = workspaceIdsInOrg.every(id => 
      updatedWorkspaceIds.includes(id)
      );

      if (areAllWorkspacesUnselected) {
        return {
          ...state,
          unselected_organization_ids: [...state.unselected_organization_ids, organization.id],
          unselected_workspace_ids: updatedWorkspaceIds.filter(id => 
          !workspaceIdsInOrg.includes(id)
          )
        };
      }

      return {
        ...state,
        unselected_workspace_ids: updatedWorkspaceIds,
        unselected_organization_ids: state.unselected_organization_ids.filter(id => 
          id !== organization.id
        )
      };
    }

    case notificationFilterConstants.RESET_ORGANIZATION_AND_WORKSPACE_FILTERS: {
      return {
        ...state,
        unselected_organization_ids: [],
        unselected_workspace_ids: []
      };
    }

    case notificationFilterConstants.SET_UNSELECTED_ORGANIZATION_IDS: {
      return {
        ...state,
        unselected_organization_ids: action.payload
      };
    }

    case notificationFilterConstants.SET_UNSELECTED_WORKSPACE_IDS: {
      return {
        ...state,
        unselected_workspace_ids: action.payload
      };
    }

  default:
    return state
  }
}


  function handleWorkspaceToggle(state, workspace) {
    const isWorkspaceUnselected = state.unselected_workspace_ids.includes(workspace.id);
    const updatedWorkspaceIds = isWorkspaceUnselected
    ? state.unselected_workspace_ids.filter(id => id !== workspace.id)
    : [...state.unselected_workspace_ids, workspace.id];

    return {
      ...state,
      unselected_workspace_ids: updatedWorkspaceIds
    };
  }

  function handleOrgUnselectedCase(state, organization, workspace, workspaceIdsInOrg) {
    return {
      ...state,
      unselected_organization_ids: state.unselected_organization_ids.filter(id => 
        id !== organization.id
      ),
      unselected_workspace_ids: [
        ...state.unselected_workspace_ids,
        ...workspaceIdsInOrg.filter(id => id !== workspace.id)
      ]
    };
  }
